__turbopack_context__.v({
  "loading-overlay-fade-in": "xnwVOW_loading-overlay-fade-in",
  "overlay": "xnwVOW_overlay",
});
